import type { RedoOrderTrackingRpcClient } from "@redotech/redo-order-tracking-rpc/client";
import { createRedoOrderTrackingRpcClient } from "@redotech/redo-order-tracking-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoOrderTrackingRpcClientContext: Context<
  RedoOrderTrackingRpcClient | undefined
> = createContext<RedoOrderTrackingRpcClient | undefined>(undefined);
RedoOrderTrackingRpcClientContext.displayName =
  "RedoOrderTrackingRpcClientContext";

export function RedoOrderTrackingRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoOrderTrackingRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoOrderTrackingRpcClient({
      baseURL: new URL(`${baseUrl}/order-tracking-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);

  return (
    <RedoOrderTrackingRpcClientContext.Provider
      value={redoOrderTrackingRpcClient}
    >
      {children}
    </RedoOrderTrackingRpcClientContext.Provider>
  );
}
